import styled from 'styled-components';

export const SearchDiv = styled.div`
    text-align: center;
    `;

export const Input = styled.input`
padding: 0.5em;
margin: 0.5em;
width: 40vh;
height: 5vh;
border-radius: .5em;
background-color: lightgray
opacity: .5;

`;
